export const SEPARATOR = '/';
export const genericValidateName = (validators) => {
    return (...names) => {
        const errs = [];
        for (const name of names) {
            const parts = name.split(SEPARATOR);
            if (parts.length !== validators.length) {
                errs.push(new Error(`name '${name}': got ${parts.length} parts, expected ${validators.length}`));
            }
            else {
                // run only if length of parts and validators matches
                validators.forEach((validator, i) => {
                    const err = validator(parts[i]);
                    if (err !== undefined) {
                        errs.push(new Error(`name '${name}' parts[${i}]: ${err.message},`));
                    }
                });
            }
        }
        if (errs.length !== 0) {
            throw new Error(errs.map((err) => err.message).join('\n'));
        }
    };
};
export const exactValidator = (expected) => {
    return (part) => {
        if (part !== expected) {
            return new Error(`got part '${part}', expected '${expected}'`);
        }
        return undefined;
    };
};
const uuidRegexString = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
export const uuidValidator = () => {
    return (part) => {
        if (!uuidRegexString.test(part)) {
            return new Error(`part '${part}'is not a valid UUID`);
        }
        return undefined;
    };
};
